module.exports = __webpack_public_path__ + "static/media/merriweather-regular-webfont.8af54a98.woff";


//////////////////
// WEBPACK FOOTER
// ./src/fonts/merriweather-regular-webfont.woff
// module id = 288
// module chunks = 0